import React from "react";

// Mui
import Fade from "@mui/material/Fade";

// Mui Styles
import { StyledPaper } from "@/styles/mui/globalStyles";
// Navigate

// Components
import DataTable from "@/components/dataTable";
import Layout from "@/components/layout";
import Title from "@/components/title";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";
// Config

import PromotionTargetDataTableToolBar from "@/components/DataTable/promotionTargetDataTableToolBar";
// Fetch
import { getAll, getProductListByTargetId } from "@/fetch/fetchPromotionTarget";
import { getPromotionTargetStatistics } from "@/fetch/fetchStatistics";
import { getRegionOptions } from "@/fetch/fetchWork";
// import { CurrencyFormat, toPercent } from "@/config/normalConfig";
import { setSelectedAm } from "@/features/dataTableSlice";
import { getRosterList } from "@/lib/getRosterList";
import _ from "lodash";
import { useDispatch } from "react-redux";

const PromotionTargetStatisticsPage = (props) => {
  const { open, setOpen } = props;
  const dispatch = useDispatch();
  // Navigate
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [amOptions, setAmOptions] = React.useState([]);
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [rowData, setRowData] = React.useState([]);
  const [columns, setColumns] = React.useState([]);
  const [promotionTargetData, setPromotionTargetData] = React.useState([]);
  const [dataTableLoading, setDataTableLoading] = React.useState(false);
  const [slideTranOn, setSlideTranOn] = React.useState(false);
  const getRowId = (row) => {
    return row.id;
  };
  const handleAmFetch = async (
    selectedPromotionTarget,
    amIds,
    promotionGrouping
  ) => {
    const { data } = await getPromotionTargetStatistics(
      selectedPromotionTarget.id,
      {
        amIds,
        groupBy: promotionGrouping,
      }
    );
    const rows = [];
    let row = {};
    const column = [
      {
        field: "am_alias",
        headerName: "AM",
        flex: 1,
      },
    ];
    const groupByAM = _.groupBy(data, (d) => `${d.id}`);
    switch (selectedPromotionTarget.type) {
      case "qty":
        const { data: products } = await getProductListByTargetId(
          selectedPromotionTarget.id
        );
        _.forEach(products, (product) => {
          column.push({
            field: String(product.id),
            headerName: product.product_name,
            minWidth: 160,
            flex: 1,
          });
          row[product.id] = 0;
        });
        _.forEach(groupByAM, (AM) => {
          let total = 0;
          const cloneRow = { ...row };
          cloneRow.id = parseInt(AM[0].id);
          cloneRow.total_target_amount = AM[0].total_target_amount;
          cloneRow.am_alias = AM[0].am_alias;
          _.forEach(AM, (product) => {
            cloneRow[String(product.product_master_id)] = parseInt(
              product.total_amount
            );
            total += parseInt(product.total_amount);
          });
          cloneRow.total = total;
          rows.push(cloneRow);
        });
        column.push(
          {
            field: "total",
            headerName: "總數（件）",
            flex: 1,
            valueFormatter: (value) =>
              `${new Intl.NumberFormat().format(value)}`,
          },
          {
            field: "total_target_amount",
            headerName: "目標數（件）",
            flex: 1,
            valueFormatter: (value) =>
              `${new Intl.NumberFormat().format(value)}`,
          },
          {
            field: "attainment_rate",
            headerName: "達標率",
            flex: 1,
            cellClassName: (params) => {
              if (params.value >= 100) {
                return "positive--cell";
              } else {
                return "negative--cell";
              }
            },
            valueGetter: (value, row) => {
              return (
                (parseInt(row.total) / parseInt(row.total_target_amount)) * 100
              );
            },
            valueFormatter: (value) =>
              `${new Intl.NumberFormat("en", {
                minimumFractionDigits: 1,
              }).format(_.round(value, 1))}%`,
          }
        );
        break;
      case "amount":
        _.forEach(data, (d) => {
          const cloneRow = { ...row };
          cloneRow.total = parseInt(d.total_amount);
          cloneRow.target_amount = parseInt(d.total_target_amount);
          cloneRow.am_alias = d.am_alias;
          cloneRow.id = d.id;
          rows.push(cloneRow);
        });
        column.push(
          {
            field: "total",
            headerName: "總數（$）",
            flex: 1,
            valueFormatter: (value) =>
              `${new Intl.NumberFormat().format(value)}`,
          },
          {
            field: "target_amount",
            headerName: "目標數（$）",
            flex: 1,
            valueFormatter: (value) =>
              `${new Intl.NumberFormat().format(value)}`,
          },
          {
            field: "attainment_rate",
            headerName: "達標率",
            flex: 1,
            cellClassName: (params) => {
              if (params.value >= 100) {
                return "positive--cell";
              } else {
                return "negative--cell";
              }
            },
            valueGetter: (value, row) => {
              return (row.total / row.target_amount) * 100;
            },
            valueFormatter: (value) =>
              `${new Intl.NumberFormat("en", {
                minimumFractionDigits: 1,
              }).format(_.round(value, 1))}%`,
          }
        );
        break;
      default:
        break;
    }

    setColumns(column);
    setRowData(rows);
  };
  const handelShopFetch = async (
    selectedPromotionTarget,
    amIds,
    promotionGrouping
  ) => {
    const { data } = await getPromotionTargetStatistics(
      selectedPromotionTarget.id,
      {
        amIds,
        groupBy: promotionGrouping,
      }
    );
    const rows = [];
    let row = { total: 0 };
    const column = [
      {
        field: "work_name",
        headerName: "店鋪",
        flex: 1,
      },
      {
        field: "alias",
        headerName: "員工",
        flex: 1,
      },

      {
        field: "roster",
        headerName: "更表",
        flex: 1,
      },
      {
        field: "am_alias",
        headerName: "AM",
        flex: 1,
      },
      {
        field: "created_at",
        headerName: "報數時間",
        flex: 1,
        valueFormatter: (value) =>
          value ? `${moment(value).format("A hh:mm")}` : "N/A",
      },
    ];
    const groupByLocationId = _.groupBy(
      data,
      (d) => `${d.work_location_id}@${d.roster}`
    );
    switch (selectedPromotionTarget.type) {
      case "qty":
        const { data: products } = await getProductListByTargetId(
          selectedPromotionTarget.id
        );
        _.forEach(products, (product) => {
          column.push({
            field: String(product.id),
            headerName: product.product_name,
            flex: 1,
            minWidth: 160,
          });
          row[product.id] = 0;
        });
        _.forEach(groupByLocationId, (location) => {
          let total = 0;
          const cloneRow = { ...row };
          cloneRow.id = parseInt(location[0].user_id);
          cloneRow.alias = location[0].alias;
          cloneRow.roster = getRosterList(location[0].roster?.toLowerCase());
          cloneRow.work_name = location[0].work_name;
          cloneRow.target_amount = location[0].target_amount;
          cloneRow.am_alias = location[0].am_alias;
          cloneRow.created_at = location[0].created_at;
          _.forEach(location, (product) => {
            const total_amount = product.total_amount
              ? parseInt(product.total_amount)
              : 0;
            cloneRow[String(product.product_master_id)] = total_amount;
            total += total_amount;
          });
          cloneRow.total = total;
          rows.push(cloneRow);
        });

        column.push(
          {
            field: "total",
            headerName: "總數（件）",
            flex: 1,
            valueFormatter: (value) =>
              `${new Intl.NumberFormat().format(value)}`,
          },
          {
            field: "target_amount",
            headerName: "目標數（件）",
            flex: 1,
            valueFormatter: (value) =>
              `${new Intl.NumberFormat().format(value)}`,
          },
          {
            field: "attainment_rate",
            headerName: "達標率",
            flex: 1,
            cellClassName: (params) => {
              if (params.value >= 100) {
                return "positive--cell";
              } else {
                return "negative--cell";
              }
            },
            valueGetter: (value, row) => {
              return (row.total / row.target_amount) * 100;
            },
            valueFormatter: (value) =>
              `${new Intl.NumberFormat("en", {
                minimumFractionDigits: 1,
              }).format(_.round(value, 1))}%`,
          }
        );

        break;

      case "amount":
        _.forEach(groupByLocationId, (locations, location_id) => {
          const cloneRow = { ...row };
          let total = 0;
          cloneRow.id = parseInt(locations[0].user_id);
          cloneRow.alias = locations[0].alias;
          cloneRow.roster = getRosterList(locations[0].roster?.toLowerCase());
          cloneRow.work_name = locations[0].work_name;
          cloneRow.target_amount = locations[0].target_amount;
          cloneRow.am_alias = locations[0].am_alias;
          cloneRow.created_at = locations[0].created_at;
          _.forEach(locations, (location) => {
            total += parseInt(location.total_amount);
          });
          cloneRow.total = total;
          rows.push(cloneRow);
        });

        column.push(
          {
            field: "total",
            headerName: "總數（$）",
            flex: 1,
            valueFormatter: (value) =>
              `${new Intl.NumberFormat().format(value)}`,
          },
          {
            field: "target_amount",
            headerName: "目標數（$）",
            flex: 1,
            valueFormatter: (value) =>
              `${new Intl.NumberFormat().format(value)}`,
          },
          {
            field: "attainment_rate",
            headerName: "達標率",
            flex: 1,
            cellClassName: (params) => {
              if (params.value >= 100) {
                return "positive--cell";
              } else {
                return "negative--cell";
              }
            },
            valueGetter: (value, row) => {
              return (row.total / row.target_amount) * 100;
            },
            valueFormatter: (value) =>
              `${new Intl.NumberFormat("en", {
                minimumFractionDigits: 1,
              }).format(_.round(value, 1))}%`,
          }
        );
        break;
      default:
        break;
    }

    setColumns(column);
    setRowData(rows);
  };
  const fetchData = async (
    selectedPromotionTarget,
    amIds,
    promotionGrouping
  ) => {
    try {
      setDataTableLoading(true);
      switch (promotionGrouping) {
        case "shop":
          handelShopFetch(selectedPromotionTarget, amIds, promotionGrouping);
          break;
        case "am":
          handleAmFetch(selectedPromotionTarget, amIds, promotionGrouping);
          break;
        default:
          break;
      }
    } catch (err) {
      setSnackSeverity("error");
      setSnackMessage(
        `發生錯誤 \n ${err.message} \n Message:${err.response.data.message}`
      );

      setSnackOpen(true);
    } finally {
      setDataTableLoading(false);
    }
  };
  const fetchTargets = async () => {
    const { data } = await getAll();
    setPromotionTargetData(data);
  };
  const fetchAM = async () => {
    const { data: workOptions } = await getRegionOptions();
    const areaManOptions = _.map(
      _.uniqBy(workOptions, "user_id"),
      (option) => ({
        am_id: option.user_id,
        am_name: option.alias,
      })
    );
    dispatch(setSelectedAm({ value: _.map(areaManOptions, "am_id") }));
    setAmOptions(areaManOptions);
    setSlideTranOn(true);
  };
  React.useEffect(() => {
    fetchTargets();
    fetchAM();
  }, []);

  moment.updateLocale("zh-hk", {
    weekdaysShort: ["日", "一", "二", "三", "四", "五", "六"],
  });

  return (
    <Layout
      header="promotionTargetStatisticsPage"
      selectedIndex={3}
      open={open}
      snackClose={() => setSnackOpen(false)}
      setOpen={setOpen}
      snackOpen={snackOpen}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
    >
      <Title title="推廣日目標" />
      <Fade in={slideTranOn} mountOnEnter unmountOnExit>
        <StyledPaper page={"yes"}>
          <DataTable
            loading={dataTableLoading}
            rows={rowData}
            promotionTargetData={promotionTargetData}
            amOptions={amOptions}
            Toolbar={PromotionTargetDataTableToolBar}
            columns={columns}
            noRowsLabel={"選擇篩選條件"}
            disableColumnFilter={false}
            checkboxSelection={false}
            pinFirstColumn={false}
            searchBarPlaceholder={"搜尋產品"}
            initialState={{
              sorting: {
                sortModel: [{ field: "attainment_rate", sort: "asc" }],
              },
            }}
            pageSize={50}
            getRowId={getRowId}
            fetchData={fetchData}
          />
        </StyledPaper>
      </Fade>
    </Layout>
  );
};

export default PromotionTargetStatisticsPage;
